import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { RachelChangedValueAppearance } from '../hooks/rachelEffects.types';
import { useRachelChangedValue } from '../hooks/useRachelChangedValue';

interface RachelChangedValueProps {
  value: unknown;
  children: ReactNode;
  appearance?: Exclude<RachelChangedValueAppearance, 'input'>;
  highlightOnMount?: boolean;
}

const RachelChangedValue = ({
  value,
  children,
  appearance = 'text',
  highlightOnMount,
}: RachelChangedValueProps) => {
  const { className } = useRachelChangedValue(value, { appearance, highlightOnMount });

  return (
    <Box component={appearance === 'field' ? 'div' : 'span'} className={className}>
      {children}
    </Box>
  );
};

export default RachelChangedValue;
